import {required} from "../../helpr/generic-validation-rules";

/*
  Authorization Field Defaults
 */
export const confirmTransferObj = obj => {
  return {
    fields: {
      transferDate: {
        value: obj.transferDate,
        style: {}
      },
      settlementDate: {
        value: obj.settlementDate,
        style: {}
      },
      fromRegistryBpId: {
        value: obj.fromRegistryBpId,
        style: {}
      },
      fromRegistryAccountNumber: {
        value: obj.fromRegistryAccountNumber,
        style: {}
      },
      toType: {
        value: obj.toType,
        style: {}
      },
      toDepositoryBpId: {
        value: obj.toDepositoryBpId,
        style: {}
      },
      toDepositoryAccountNumber: {
        value: obj.toDepositoryAccountNumber,
        style: {}
      },
      toRegistryBpId: {
        value: obj.toRegistryBpId,
        style: {}
      },
      toRegistryAccountNumber: {
        value: obj.toRegistryAccountNumber,
        style: {}
      },
    },
    dynamicFields: {}
  }
}

export const confirmTransferValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    transferDate: [required],
    settlementDate: [required],
    fromRegistryBpId: [required],
    fromRegistryAccountNumber: [required],
    toType: [required],
    toDepositoryBpId: [required],
    toDepositoryAccountNumber: [required],
    toRegistryBpId: [required],
    toRegistryAccountNumber: [required],
  },
  dynamicFields: {}
}
